import { createDismissedFlag } from "./createDismissedFlag";

// Per-project "Regenerate later"/"Update later" dismissal for the floating
// out-of-date publication widget (see MED-6969) — persisted so it survives
// a reload, and wiped on logout like the rest of localStorage
// (authService.clearAll doesn't preserve this prefix).
export const outOfDatePublicationDismissed = createDismissedFlag(
  "out-of-date-publication-dismissed"
);
